// Setup › DATA › Costs (`/c/{slug}/setup/costs`): the company cost ledger (`core`, managers).
import { createRoute } from "@tanstack/react-router";
import { CostsPage } from "../features/costs/costs-page";
import { useCompany } from "../features/use-feature";
import { setupRoute } from "./c.$slug.setup";

export const setupCostsRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "costs",
  component: function SetupCosts() {
    const { api } = setupCostsRoute.useRouteContext();
    return <CostsPage api={api} company={useCompany()} />;
  },
});
